import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { TradeInStockContainerModel } from '../../../../../../models/aggregates/erp/tradein';

@Injectable({
  providedIn: 'root'
})
export class TradeInStockService extends BaseApiTemplateService<TradeInStockContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'trade-in/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'trade-in/backoffice-ep';
    this.httpClient = http;
  }
}
